export const SPECIAL_PRODUCTS = {
    'musalla' :{title: 'Sponsor a musalla' , subtitle: 'sustains one Musalla for 365 days', goal: 800, unit: 'Musalla', },
}
export const SPECIAL_PRODUCTS_LIST = [{key: 'Musalla', value: 'musalla'}, {key: 'Custom Waffle Chart', value: 'waffle'}]